<template>
  <div style="position: relative">
    <v-form v-model="valid" v-on:submit="submit">
      <v-jsf v-model="data" :options="options" :schema="schema" />
    </v-form>
    <button v-if="$checkRoles(['Administrator'])"
            class="ark-btn ark-btn--default" @click="submit">
      Save categories
    </button>
  </div>
</template>

<script>
import config from "../../../config";

export default {
  name: "ManageCategories",
  props: ["selectedArena"],
  data: function() {
    return {
      valid: false,
      data: {
        homeCategories: this.selectedArena.config.categories.homeCategories || [],
        allCategories: this.selectedArena.config.categories.allCategories.map(it => {
          return { "name": it };
        }) || []
      },
      options: { "hideReadOnly": true, "editMode": "inline" },
      schema: {
        "type": "object",
        "additionalProperties": false,
        "properties": {
          "allCategories": {
            "title": "Categories(top menu)",
            "type": "array",
            "items": {
              "type": "object",
              "additionalProperties": false,
              "properties": {
                "name": {
                  "type": "string"
                }
              }
            }
          },
          "homeCategories": {
            "type": "array",
            "items": {
              "type": "object",
              "additionalProperties": false,
              "properties": {
                "name": {
                  "type": "string"
                }
              }
            }
          }
        }
      }
    };
  },
  watch: {
    'selectedArena.config.categories' : function() {
      if (this.selectedArena.config.categories.allCategories) {
        this.data.allCategories = this.selectedArena.config.categories.allCategories.map(it => {
          return { "name": it };
        });
      }
      if (this.selectedArena.config.categories.homeCategories) {
        this.data.homeCategories = this.selectedArena.config.categories.homeCategories;
      }
    }
  },
  methods: {
    submit: function() {
      this.$http.post(`${config.apiUrl}/arena/categories/save`, {
        allCategories: this.data.allCategories.map(it => it.name),
        homeCategories: this.data.homeCategories
      }, {
        params: { domain: this.selectedArena.domain }
      }).then(
        () => {
          this.$swal.fire({
            icon: "success",
            title: "Success!",
            text: "Categories was saved successfully"
          });
        },
        (error) => {
          this.$swal.fire({
            icon: "error",
            title: "Error!",
            text: "Something went wrong, please contact WebPortals."
          });
          console.log(error);
        }
      );
    }
  }
};
</script>

